import { Navigate, Outlet } from "react-router-dom";

const Protected = () => {
  const auth = localStorage.getItem("token");

  return auth ? <Navigate to="/games" /> : <Outlet />;
};

export default Protected;